import { Breakpoint } from "@/shared/models/breakpoint-type";
import { ISocialThemeItem } from "../interfaces/social-theme-item";

export default interface ISocialThemeWidgetState{
    themeItems: ISocialThemeItem[];
    maxAmount: number;
    currentBreakpoint: Breakpoint;
}

export class SocialThemeWidgetState implements ISocialThemeWidgetState {
    themeItems: ISocialThemeItem[] = []
    maxAmount: number = 8;
    currentBreakpoint: Breakpoint = Breakpoint.Desktop;
}